import { useState } from "react";
import { FileText, FileDown } from "lucide-react";
import { toast } from "sonner";
import { downloadFile, errMsg } from "@/lib/api";
import { inputClass } from "@/components/FieldInput";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export function ReportButton({ trust }) {
  const [open, setOpen] = useState(false);
  const [year, setYear] = useState(new Date().getFullYear() - 1);
  const [busy, setBusy] = useState(null);
  const years = Array.from({ length: 12 }, (_, i) => new Date().getFullYear() - i);
  const slug = (trust.name || "trust").replace(/[^a-zA-Z0-9]/g, "_").slice(0, 40);

  const get = async (fmt) => {
    setBusy(fmt);
    try {
      await downloadFile(`/reports/trust/${trust.id}/rendiconto?year=${year}&format=${fmt}`, `Rendiconto_${year}_${slug}.${fmt}`);
      toast.success("Rendiconto generato");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(null); }
  };

  return (
    <>
      <Button variant="outline" size="sm" onClick={() => setOpen(true)} data-testid="report-open-button"><FileText className="h-4 w-4 mr-1" />Rendiconto annuale</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-white max-w-md" data-testid="report-dialog">
          <DialogHeader>
            <DialogTitle className="font-heading">Rendiconto annuale</DialogTitle>
            <DialogDescription>Dati del Trust, soggetti, patrimonio al 31/12, movimenti e saldi contabili, adempimenti fiscali, scadenze e diario. Ogni generazione è registrata nel log di audit.</DialogDescription>
          </DialogHeader>
          <label className="text-xs font-semibold text-slate-600">Esercizio</label>
          <select className={inputClass} value={year} onChange={(e) => setYear(Number(e.target.value))} data-testid="report-year-select">
            {years.map((y) => <option key={y} value={y}>{y}</option>)}
          </select>
          <div className="grid grid-cols-2 gap-2 mt-2">
            <Button disabled={!!busy} onClick={() => get("pdf")} className="bg-[#0A2540] hover:bg-[#031B33] text-white" data-testid="report-pdf-button"><FileDown className="h-4 w-4 mr-1" />{busy === "pdf" ? "Generazione…" : "PDF"}</Button>
            <Button disabled={!!busy} variant="outline" onClick={() => get("docx")} data-testid="report-docx-button"><FileDown className="h-4 w-4 mr-1" />{busy === "docx" ? "Generazione…" : "Word"}</Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
